import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const ArrowLeftIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('ArrowLeftIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.469 13.037 1.25 8.818m0 0L5.469 4.6M1.25 8.818h13.5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
ArrowLeftIcon.id = 'ArrowLeftIcon';
ArrowLeftIcon.displayName = 'ArrowLeftIcon';
export default ArrowLeftIcon;
